import Vue from 'vue'
import { iHttp } from 'smart-core-util'
import url from './apis/urls'
import configuration from './configuration'
import { Toast, Indicator } from 'mint-ui'
Vue.prototype.configuration = configuration;
Vue.prototype.url = url;
Vue.prototype.api = new iHttp({
  baseURL: configuration.gateway,
  alert: Toast,
  block: Indicator.open,
  unblock: Indicator.close
}).api



// WEBPACK FOOTER //
// ./src/global.js